import React, { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import AddIcon from "@mui/icons-material/Add";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { QrCodeScannerOutlined } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import DeleteIcons from "@mui/icons-material/Delete";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import BackBtn from "../BackBtn";
import MultipleChoice from "./CreateQuestions/MultipleChoice";
import YesNoQue from "./CreateQuestions/YesNoQue";
import TrueFalseQue from "./CreateQuestions/TrueFalseQue";
import EmotionsQue from "./CreateQuestions/EmotionsQue";
import SelectDateTime from "./SelectDateTime";
import TextChoiceQue from "./CreateQuestions/TextChoiceQue";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { BackArrowIcon } from "../../../Icons";
import apiClient from "../../../apiClient";

const CreateQuestions = () => {
  const location = useLocation();
  const { state } = location;
  const [show, setShow] = useState(false);
  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const [questions, setQuestions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [endTime, setEndTime] = useState("");
  const [expiryTime, setExpirytime] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imgUrl, setUrl] = useState("");
  const [save, setSave] = useState(false);
  const [isDone, setDone] = useState(true);
  const navigate = useNavigate();

  const { BackButton } = UiComponents;
  const QueOptions = [
    { value: "MULTIPLE", label: "Multiple Choice" },
    { value: "BOOLEAN", label: "Yes/No" },
    { value: "TEXT", label: "Text" },
    { value: "MOOD", label: "Emotions" },
  ];

  const handleOptionChange = (selectedOption, index) => {
    setSelectedOptions((prevOptions) => {
      const newOptions = [...prevOptions];
      newOptions[index] = selectedOption;
      return newOptions;
    });
    let defaultOptions = [];
    switch (selectedOption.value) {
      case "MULTIPLE":
        defaultOptions = [{ id: 1, name: "" }];
        break;
      case "BOOLEAN":
        defaultOptions = [
          { id: 1, letter: "a", name: "Yes", removable: false },
          { id: 2, letter: "b", name: "No", removable: false },
        ];
        break;
      case "TEXT":
        defaultOptions = [{ id: 1, name: "" }];
        break;
      case "MOOD":
        defaultOptions = [
          { id: 1, name: "Happy", removable: false },
          { id: 2, name: "Ok", removable: false },
          { id: 3, name: "Sad", removable: false },
        ];
        break;
      default:
        defaultOptions = [{ id: 1, name: "" }];
    }
    setQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      updatedQuestions[index].type = selectedOption.value;
      updatedQuestions[index].options = defaultOptions;
      return updatedQuestions;
    });
  };

  const { uuid } = useParams();

  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      boxShadow: "none",
    }),
  };

  const openDateTime = () => {
    setShow(true);
  };

  const hideDateTime = () => {
    setShow(false);
  };

  const getFeedBackData = async () => {

    let response = await apiClient.get(`${configData.config.UNO_URL}/api/feedback/getFeedback/${uuid}`);

    // const { data } = await axios.get(`${configData.config.UNO_URL}/api/feedback/getFeedback/${uuid}`, {
    //   headers: {
    //     Authorization: `Bearer ${userData.token}`,
    //   },
    // });

    setType(response.type);
    setTitle(response.name);

    if (response.data) {
      setQuestions(response.data || []);
    } else {
      addDefaultQuestion();
    }

    setUrl(response.thumbnail || "");
    setExpirytime(response.expiryTime || "");
    if (response.data) {
      const initialSelectedOptions = response.data.map((question) =>
        QueOptions.find((option) => option.value === question.type)
      );
      setSelectedOptions(initialSelectedOptions);
    }
  };

  useEffect(() => {
    getFeedBackData();
  }, []);

  const addDefaultQuestion = () => {
    const defaultQuestion = {
      id: 1,
      name: "",
      type: "MULTIPLE",
      options: [{ id: 1, name: "" }],
    };
    setQuestions([defaultQuestion]);
  };
  const onDrop = useCallback(async (acceptedFiles) => {
    const formData = new FormData();
    formData.append("file", acceptedFiles[0]);

    try {
      const response = await axios.post(
        `${configData.config.UNO_URL}/api/resource/upload/feedback/thumbnail/${uuid}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type ": "multipart/form-data",
          },
        }
      );
      setUrl(response.data.url || "");
    } catch (error) {
      console.error("Error:", error);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/jpeg": [".jpg", ".jpeg"],
      "image/png": [".png"],
    },
    multiple: true,
  });
  const { useUnoSelector } = UnoStoreHooks;
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);

  const handleDeleteQuestion = (index) => {
    const updatedQuestions = [...questions];
    updatedQuestions.splice(index, 1);
    setQuestions(updatedQuestions);
  };

  const handleAddNewQuestion = () => {
    addNewQuestion();
  };
  const addNewQuestion = () => {
    const newQuestion = {
      id: questions.length + 1,
      options: selectedOptions[questions.length] ? selectedOptions[questions.length].options : [],
    };
    setQuestions([...questions, newQuestion]);
  };
  const handleSaveFeedback = async () => {
    try {
      const payload = {
        questions,
        thumbnail: imgUrl,
      };
      setIsSubmitting(true);

      await apiClient.post(`${configData.config.UNO_URL}/api/feedback/update/${uuid}`, payload);

      // const response = await axios.post(`${configData.config.UNO_URL}/api/feedback/update/${uuid}`, payload, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //   },
      // });

      setIsSubmitting(false);
      setSave(false);
      setDone(false);

    } catch (error) {
      console.error("API request error:", error);
    }
  };

  const handleSave = () => {
    setSave(true);
    setDone(true);
  };

  return (
    <>
      <div className="bg-grey-main createstions">
        <div className=" row d-flex ">
          <div className="col-md-6">
            <div
              className="cursor-pointer d-flex back-div page-title with-fuctions"
              onClick={() =>
                navigate(`/feedback/${userData?.user?.group?.uuid}`, {
                  state: { key: state?.key || "analytics" },
                })
              }
            >
              {" "}
              <BackButton Icon={<BackArrowIcon />} />
              {/* <KeyboardBackspaceIcon /> */}
              <h6> Feedback & Survey</h6>
            </div>
          </div>
          {/* <div className="col-md-6">
            <div className="text-end">
              <div
                onClick={() => navigate(`/feedback/feedback-preview/${uuid}`)}
                className="btn btn-sm btn-danger"
              >
                Preview
              </div>
            </div>
          </div> */}
          <div className="feedback-survey mt-3" style={{ position: "sticky", top: "0" }}>
            <div className="row mt-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="beedbackbanner" {...getRootProps()}>
                      <input {...getInputProps()} />
                      {!imgUrl.length > 0 ? (
                        <>
                          <div className="upload-section">
                            <div className="text-upload ">
                              <FileUploadOutlinedIcon />
                              <h6 className="m-0 font-xs">Upload banner</h6>
                            </div>
                            <p className="font-xss">Allowed file( jpg, jpeg, png ) and Drop the files here ...</p>
                          </div>
                        </>
                      ) : (
                        <>
                          <img src={imgUrl} alt="" />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    {/* {feedback.status.charAt(0).toUpperCase() + feedback.status.slice(1).toLowerCase()} */}
                    <h6 className="d-flex gap-2">
                      <strong>{type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()} Title: </strong>{" "}
                      <span className="text-capitalize">{title}</span>{" "}
                    </h6>
                    {questions?.length > 0 &&
                      questions.map((question, index) => (
                        <div key={index} className="bg-light p-4">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="d-flex gap-4 align-items-center">
                                <h5>
                                  <strong>{`Q${index + 1}`}</strong>
                                </h5>
                                <div className="d-flex w-100 gap-4">
                                  <input
                                    type="text"
                                    className="form-control creatq"
                                    placeholder="Enter your Question"
                                    value={question.name}
                                    onChange={(e) => {
                                      const updatedQuestions = [...questions];
                                      updatedQuestions[index].name = e.target.value;
                                      setQuestions(updatedQuestions);
                                      handleSave();
                                    }}
                                  />
                                  <Select
                                    className="form-control coptff"
                                    styles={style}
                                    placeholder="Select type of questions"
                                    options={QueOptions}
                                    value={selectedOptions[index]}
                                    onChange={(selectedOption) => {
                                      handleOptionChange(selectedOption, index);
                                      handleSave();
                                    }}
                                  />
                                  <span
                                    className="text-upload ps-2 pt-3 cursor-pointer  "
                                    onClick={() => {
                                      handleDeleteQuestion(index);
                                      handleSave();
                                    }}
                                  >
                                    <DeleteIcons />{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mt-4">
                            {question.type === "MULTIPLE" && (
                              <MultipleChoice
                                options={question.options}
                                setOptions={(newOptions) => {
                                  const updatedQuestions = [...questions];
                                  updatedQuestions[index].options = newOptions;
                                  setQuestions(updatedQuestions);
                                }}
                              />
                            )}
                            {question.type === "BOOLEAN" && (
                              <YesNoQue
                                options={question.options}
                                setOptions={(newOptions) => {
                                  const updatedQuestions = [...questions];
                                  updatedQuestions[index].options = newOptions;
                                  setQuestions(updatedQuestions);
                                }}
                              />
                            )}

                            {question.type === "TEXT" && <TextChoiceQue />}

                            {question.type === "MOOD" && (
                              <EmotionsQue
                                options={question.options}
                                setOptions={(newOptions) => {
                                  const updatedQuestions = [...questions];
                                  updatedQuestions[index].options = newOptions;
                                  setQuestions(updatedQuestions);
                                }}
                              />
                            )}
                          </div>
                        </div>
                      ))}

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <button
                          className="btn-save btn btn-sm"
                          onClick={() => {
                            handleAddNewQuestion();
                            handleSave();
                          }}
                        >
                          <AddIcon /> {questions.length === 0 ? "Create First Question" : "Next Question"}
                        </button>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex gap-3 justify-content-end">
                          {/* <button className="btn btn-sm btn-light btn-cancel">Cancel</button> */}
                          <button
                            className="btn-save btn btn-sm "
                            onClick={handleSaveFeedback}
                            disabled={isSubmitting || !save}
                          >
                            {isSubmitting ? "Saving..." : "Save"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-12">
                <div className="d-flex justify-content-center">
                  <button onClick={openDateTime} className="btn btn-save p-2 px-4" disabled={isDone}>
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SelectDateTime show={show} handleClose={hideDateTime} expiryTime={expiryTime} />
    </>
  );
};

export default CreateQuestions;
